import { createRootSelector } from "../../../utils/createSelector.mjs";
export const gridColumnMenuSelector = createRootSelector(state => state.columnMenu);